module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/5/2-b4fcf96dfc5d338a2fc781bec8327fbd.jpg";